import { render, staticRenderFns } from "./AgentModelForm.vue?vue&type=template&id=ffab8624&scoped=true"
import script from "./AgentModelForm.vue?vue&type=script&lang=js"
export * from "./AgentModelForm.vue?vue&type=script&lang=js"
import style0 from "./AgentModelForm.vue?vue&type=style&index=0&id=ffab8624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffab8624",
  null
  
)

export default component.exports